import RegistrationWizard from './RegistrationWizard';

export interface Account {
  id: string;
  accountNumber: string;
  accountName: string;
  balance: number;
  currency: string;
};

export default RegistrationWizard;